import { useMutation, gql, MutationHookOptions } from "@apollo/client";

export type InsertUserInput = {
  id?: string;
  email: string;
  name: string;
  companyId: string;
  avatar: string;
  role: string;
  groupIds: string[];
};

export type Talent = {
  id: string;
  email: string;
  name: string;
  companyId: string;
  avatar: string;
  role: string;
};

export const INSERT_TALENT = gql`
  mutation insertUser($input: InsertUserInput!) {
    insertUser(input: $input) {
      talent {
        id
        email
        name
        companyId
        role
        avatar
      }
    }
  }
`;

export default (options?: MutationHookOptions<any, Record<string, any>>) => {
  return useMutation(INSERT_TALENT, options);
};
